import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-monthly-expenses',
    templateUrl: './monthly-expenses.component.html',
    styleUrls: ['./monthly-expenses.component.scss'],
    standalone: false
})
export class MonthlyExpensesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
 
}
